import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import {
	NAME as name,
	DEPENDENT_TABLES_ALL as depTableNames,
	CRUMB_LABEL_KEY,
	ZAKAZKA_ND,	PART_RETURN_REQ_DETAILS,
} from '../../constants';
import { apiProvider } from '../../api';
import { dropdownList, edit, props } from './state';
import { actions as extraActions } from './actions';
import { mutations as extraMutations } from './mutations';

export const PART_RETURN_REQUEST = 'PartReturnRequest';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[ZAKAZKA_ND]: {
			filter(state) {
				return {
					zakazkaId: state.edit.OrderNo,
					SelectItems: localStorage.selectedValues,
				};
			},
		},
		[PART_RETURN_REQ_DETAILS]: {
			filter(state) {
				return {
					Id: Object(state.props).id,
				};
			},
		},
	},
	localState: {
		tiskDialog: {
			visible: false as boolean | null,
			url: null as string | null,
			filter: null as Record<string, any> | null,
			fetchPdfProvider: null as ((filter: {}) => Promise<any>) | null,
			dialogClosed: () => {},
		},
	},
	extraActions,
	extraGetters: {},
	extraMutations,
	props,
});
